import { useGetAllVersions } from '../api';
import { useConstructorActiveVersion } from '../model/slices';

export const useConstructorCurrentVersion = () => {
    const { data } = useGetAllVersions({});
    const activeVersion = useConstructorActiveVersion();

    return data?.versions.find((version) => version.id === activeVersion);
};
